const filterRegexp = /[|\\{}()[\]^$+*?.]/g;
export default function escapeRegexp(str: string): string {
  return str.replace(filterRegexp, '\\$&');
}
